<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <b-alert variant="danger" :show="showErrorLogin">{{this.message}}</b-alert>
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody style="padding-left: 0px;padding-right: 0px;">
                <h1>Login</h1>
                <b-container fluid style="padding-left: 0px; padding-right: 0px;">
                  <b-row cols="12">
                    <b-col sm="12" md="12" lg="12" xl="12">                      
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-button disabled>
                            <b-icon icon="person"></b-icon>
                          </b-button>
                        </b-input-group-prepend>                        
                        <the-mask 
                          id="cnpj"
                          v-model="login.cpf_cnpj"
                          :mask="['###.###.###-##', '##.###.###/####-##']"
                          :class="'form-control'"
                          placeholder="CPF / CNPJ"/>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row cols="12">
                    <b-col sm="12" md="12" lg="12" xl="12">                      
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-button disabled>
                            <b-icon icon="lock-fill"></b-icon>
                          </b-button>
                        </b-input-group-prepend>                        
                        <b-input 
                          v-model="login.password"
                          id="password"
                          type="password"
                          placeholder="Senha">
                        </b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row cols="12">
                    <b-col sm="12" md="12" lg="12" xl="12">                      
                      <b-button block variant="info" @click="autenticar">
                        <b-icon icon="lock-fill"></b-icon>
                        Acessar
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>                                
              </CCardBody>
            </CCard>
            <CCard
              class="text-center d-md-down-none">
              <CCardBody>
                <b-img src="../sysped/logo_full.png" width="250px" height="250px"/>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <b-modal
      id="seleciona_empresa"
      header-bg-variant="info"
      :title="'Selecione a empresa'"
      size="lg"
      no-close-on-esc>
      
      <b-form-select 
        v-model="empresaSelecionada" 
        :options="empresaOptions">
      </b-form-select>

      <template v-slot:modal-footer>
        <div>
          <b-button variant="warning" @click="acessar" id="btn_acessar"> Entrar com a empresa selecionada </b-button>
        </div>          
      </template>

    </b-modal>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask';
import LoginService from '@/services/Login';
import settings from "@/settings";

export default {
  name: 'Login',

  components: {
    TheMask
  },

  data() {
    return {
      login: {
        cpf_cnpj: "",
        password: ""
      },
      empresas: [],
      empresaOptions: [],
      empresaSelecionada: null,
      showErrorLogin: false,
      message: "",
    }
  },

  methods: {
    
    autenticar() {     
      this.empresaOptions = []; 
      if ((this.login.cpf_cnpj == '') || (this.login.password == ''))
        this.errorOnLogin('Informe login / senha');
      else {
        let loader = this.$loading.show({});
        LoginService.login(this.login.cpf_cnpj, this.login.password)
        .then(
          response => {
            if (response.data.RET == 0)
              this.errorOnLogin(response.data.OBJ[0].MSG);
            else {
              this.empresas = response.data.OBJ;              

              if (this.empresas.length > 1) {
                for (let i = 0; i < this.empresas.length; i++) {
                  let option = {};
                  option.text = this.empresas[i].EMPRESA_NOME;
                  option.value = this.empresas[i].EMPRESA;
                  this.empresaOptions.push(option);
                }

                this.$bvModal.show("seleciona_empresa");              
              } else {
                this.empresaSelecionada = this.empresas[0].EMPRESA;
                this.acessar();
              }
            }
          }
        )
        .catch((error) => {
          if (error == "Error: Network Error")
            this.errorOnLogin("Não possível conectar no servidor. Por favor, verifique a sua conexão e tente novamente.");    
          else if (error.response.status === 404)
            this.errorOnLogin(error.response.data);
          else 
            this.errorOnLogin(error);
        })
        .finally(() => {
          loader.hide();
        });
      }
    },

    errorOnLogin(message) {
      this.message = message;
      this.showErrorLogin = true;      
    },

    acessar() {    
      for (let i = 0; i < this.empresas.length; i++) {
        if (this.empresas[i].EMPRESA == this.empresaSelecionada) {
          localStorage.setItem("user_sysped", JSON.stringify(this.empresas[i]));
          this.$router.push({path: settings.routes.dashboard});
        }        
      }      
    }
  }
}
</script>
